var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"online-seminar"},[_c('seminar-header',{attrs:{"event":_vm.event}}),_c('program-section'),_c('key-value-section'),_c('country-seminars-section'),_c('features-section'),_c('benefits-section'),_c('experts-section',{attrs:{"experts":_vm.experts}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }